export default "__VITE_ASSET__C2U16ZJ9__"